import { Box, Typography, SvgIcon } from '@mui/material'
import { useTranslation } from 'react-i18next'

import AlertIcon from '@hapana/shared/web/styles/assets/svgs/exclamation-circle.svg'

import { styles } from './impersonation-banner.styles'

const ImpersonationBanner = ({ staffUser, adminUser }) => {
  const { t } = useTranslation('core')

  const adminName = adminUser?.name || adminUser?.email

  return (
    <Box sx={styles.container}>
      <SvgIcon component={AlertIcon} sx={styles.icon} />
      <Typography sx={styles.text}>
        {t('impersonation.banner.message', { adminName, name: staffUser?.name })}
      </Typography>
    </Box>
  )
}

export default ImpersonationBanner
